import { Text } from "@mantine/core";
import spinner from "img/spinner1.gif"

const LoadSpinner = () => {
    return (
        <div style={{
          //  fontSize: 14,
            height: "30px",
          }}>
            <Text fz="xl" c="blue">잠시만 기다려 주세요 ........</Text>
            <img src={spinner} />
        </div>
    )
}

export default LoadSpinner;
